export default __webpack_public_path__ + "static/media/lock.f6fb6508.svg";